/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */
/* global Liferay */


export const config = {
	agentOauthAppId: 'liferay-lms-etc-node-oauth-application-user-agent',

	agentOauthSpringAppId: 'liferay-learn-etc-spring-boot-oaua',

	modulesViewComponent : 'liferay-lms-modules-view',

	lessonsViewComponent : 'liferay-lms-lessons-view',

	lessonsCompactViewComponent : 'liferay-lms-lessons-compact-view',
};

export const ENDPOINT = Object.freeze({
  ASSESSMENTS: '/o/c/p2s3assessments',

  BADGES: '/o/c/p2s3badges',

  CERTIFICATIONS: '/o/c/p2s3certifications',

	COURSES: '/o/c/p2s3courses',

	ENROLLMENTS: '/o/c/p2s3enrollments',

	EXAM_RESULTS: '/o/c/p2s3examresults',

	EXERCISES: '/quizes',

	EXTERNAL_MEDIA: '/o/c/p2s3externalmedias',

	FAQ_TOPICS: '/o/c/p2s3faqtopics',

	LEARNING_PATHS: '/o/c/p2s3learningpaths',

	LEARNING_PATH_STEPS: '/o/c/p2s3learningpathsteps',

	LESSONS: '/o/c/p2s3lessons',

	MENU: '/menu',

	MENU_ITEMS: '/menu/items',

	MODULES: '/o/c/p2s3modules',

	PROGRESS: '/progress',

	QUIZZES: '/o/c/p2s3quizes',

	QUIZ_QUESTIONS: '/o/c/p2s3quizquestions',

	QUIZ_ANSWERS: '/o/c/p2s3quizanswers',

	QUIZ_RESULTS: '/o/c/p2s3quizresults',

	USER_BADGES: '/o/c/p2s3userbadges',

	USER_UTILS: '/user',

	UTILS: '/utils',
});

export const RELATIONSHIP = Object.freeze({
	
	LEARNING_PATHS_TO_LEARNING_PATHS_STEPS : 'p2s3LearningPathToP2S3LearningPathSteps',

	LEARNING_PATHS_TO_ENROLLMENTS : 'p2s3LearningPathToP2S3Enrollments',

	EXTERNAL_MEDIA_TO_LEARNING_PATH_STEPS : 'p2S3ExtMediaToP2s3LPSteps',

	COURSES_TO_ENROLLMENTS : 'p2s3CourseToP2S3Enrollments',

	COURSES_TO_MODULES : 'p2s3CourseToP2S3Modules',

	COURSES_TO_LEARNING_PATH_STEPS : 'p2s3CourseToP2S3LPSteps',

	MODULES_TO_LESSONS : 'p2s3ModuleToP2S3Lessons',

	MODULES_TO_QUIZZES : 'p2s3ModuleToP2S3Quizzes',

	QUIZZES_TO_QUIZZES_QUESTIONS : 'p2s3QuizToP2S3QuizQuestions',

	QUIZZES_TO_QUIZZES_RESULTS : 'p2s3QuizToP2S3QuizResults',

	QUIZZES_TO_BADGES : 'p2s3QuizToP2S3Badges',

	QUIZZES_QUESTIONS_TO_QUIZZES_ANSWERS : 'p2s3QuizQuestionToP2S3QuizAnswers',

	CERTIFICATIONS_TO_ASSESSMENTS : 'p2s3CertificationToP2S3Assessments',

	ASSESSMENTS_TO_LEARNING_PATHS : 'p2s3AssessmentToP2S3LearningPaths',

	FAQ_TOPICS_TO_QUESTIONS : 'p2s3TopicToP2S3Questions',

});

export const RELATIONSHIP_FIELD = Object.freeze({
	ASSESSMENTS_IN_LEARNING_PATHS : 'r_p2S3AssessmentToP2S3LearningPaths_c_p2s3AssessmentId',

	LEARNING_PATHS_IN_LEARNING_PATH_STEPS : 'r_p2s3LearningPathToP2S3LearningPathSteps_c_p2s3LearningPathId',

	EXTERNAL_MEDIA_IN_LEARNING_PATH_STEPS : 'r_p2S3ExtMediaToP2s3LPSteps_c_p2s3ExternalMediaId',

	COURSES_IN_LEARNING_PATH_STEPS : 'r_p2s3CourseToP2S3LPSteps_c_p2s3CourseId',

	COURSES_IN_MODULES : 'r_p2s3CourseToP2S3Modules_c_p2s3CourseId',

	MODULES_IN_LESSONS : 'r_p2s3ModuleToP2S3Lessons_c_p2s3ModuleId',

	QUIZZES_IN_MODULES : 'r_p2s3ModuleToP2S3Quizzes_c_p2s3ModuleId',

	QUIZZES_IN_QUIZZES_QUESTIONS : 'r_p2s3QuizToP2S3QuizQuestions_c_p2s3QuizId',

	QUIZZES_QUESTIONS_IN_QUIZZES_ANSWERS : 'r_p2s3QuizQuestionToP2S3QuizAnswers_c_p2s3QuizQuestionId',

	USER_IN_QUIZZES_RESULTS : 'r_lUserToP2S3QuizResults_userId',

	QUIZZES_IN_QUIZZES_RESULTS : 'r_p2s3QuizToP2S3QuizResults_c_p2s3QuizId',

	COURSES_IN_ENROLLMENTS : 'r_p2s3CourseToP2S3Enrollments_c_p2s3CourseId',

	LEARNING_PATHS_IN_ENROLLMENTS : 'r_p2s3LearningPathToP2S3Enrollments_c_p2s3LearningPathId',

	USERS_IN_ENROLLMENTS : 'r_lUserToP2S3Enrollments_userId',

	QUIZZES_IN_BADGES : 'r_p2s3QuizToP2S3Badges_c_p2s3QuizId',

	BADGES_IN_USER_BADGES : 'r_lUserToP2S3UserBadges_userId',

	CERTIFICATIONS_IN_ASSESSMENTS : 'r_p2S3CertificationToP2S3Assessments_c_p2s3CertificationId',

})

export const RELATIONSHIP_NAME = Object.fromEntries(
	Object.entries(RELATIONSHIP_FIELD).map(([key, value]) => [
		key,
		value.replace(/Id$/, ''), 
	])
);

export const LANDING_PAGE_VIEW_TYPE = Object.freeze({
	CERTIFICATION : 'certification',

	COURSE : 'course',

	LEARNING_PATH : 'learningPath',
});

export const OBJECT_ENTRY_URL_SEPARATOR = Object.freeze({
	ANNOUNCEMENT : 'announcement',

	CERTIFICATION : 'certification',

	KNOWLEDGE_ARTICLE : 'kb-article',
	
	LEARNING_PATH : 'learning-path',
	
	LESSON : 'course',
	
	QUIZ : 'quiz',
	
	TRAINER_KIT : 'trainer-kit',
});